module.exports = ".dx-button {\n    margin: 10px;\n    float: right;\n}\n\n.dx-datebox-date {\n    width: 100% !important;\n}\n\n.hidden {\n    display: none;\n}\n\n.dx-field-label {\n    width: 33% !important;\n}\n\n.dx-field-value {\n    width: 66% !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/single-view-custom-action/single-view-custom-action.component.css
// module id = ./src/app/components/single-view-custom-action/single-view-custom-action.component.css
// module chunks = main